export default __webpack_public_path__ + "static/16aa-e0f229e0018b35522c911a337fdb19d8.png";